<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import Button from 'dashboard/components-next/button/Button.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useMapGetter } from 'dashboard/composables/store';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const route = useRoute();

const { uiSettings, updateUISettings } = useUISettings();

const isConversationRoute = computed(() => {
  const CONVERSATION_ROUTES = [
    'inbox_conversation',
    'conversation_through_inbox',
    'conversations_through_label',
    'team_conversations_through_label',
    'conversations_through_folders',
    'conversation_through_mentions',
    'conversation_through_unattended',
    'conversation_through_participating',
    'inbox_view_conversation',
  ];
  return CONVERSATION_ROUTES.includes(route.name);
});

// ✅ Nova função para detectar rotas de campanha
const isCampaignRoute = computed(() => {
  const CAMPAIGN_ROUTES = [
    // Rotas WhatsApp Oficial
    'campaigns_whatsapp_official',
    'campaigns_whatsapp_official_home',
    'campaigns_whatsapp_official_schedule',
    'campaigns_whatsapp_official_schedule_deliveries',
    'campaigns_whatsapp_official_schedule_list',
    'campaigns_whatsapp_official_home_create',
    'campaigns_whatsapp_official_configure_list',
    'campaigns_whatsapp_official_schedule_step',
    'campaigns_whatsapp_official_finish',

    // Rotas WhatsApp App
    'campaigns_whatsapp_app',
    'campaigns_whatsapp_app_schedule',
    'campaigns_whatsapp_app_schedule_deliveries',
    'campaigns_whatsapp_app_schedule_list',
    'campaigns_whatsapp_app_home_create',
    'campaigns_whatsapp_app_configure_list',
    'campaigns_whatsapp_app_schedule_step',
    'campaigns_whatsapp_app_finish',
  ];

  // Também verifica se o path contém 'campaigns' como fallback
  const pathContainsCampaigns = route.path.includes('/campaigns');

  return CAMPAIGN_ROUTES.includes(route.name) || pathContainsCampaigns;
});

const isTelephonyRoute = computed(() => {
  return (
    route.path.includes('/telephony') ||
    route.path.includes('/whatsapp-voice') ||
    route.path.includes('/whatsapp-calling')
  );
});

const isStudioRoute = computed(() => {
  return route.path.includes('/studio');
});

const currentAccountId = useMapGetter('getCurrentAccountId');
const isFeatureEnabledonAccount = useMapGetter(
  'accounts/isFeatureEnabledonAccount'
);

const showCopilotLauncher = computed(() => {
  const isCaptainEnabled = isFeatureEnabledonAccount.value(
    currentAccountId.value,
    FEATURE_FLAGS.CAPTAIN
  );
  return (
    isCaptainEnabled &&
    !uiSettings.value.is_copilot_panel_open &&
    !isConversationRoute.value &&
    !isCampaignRoute.value &&
    !isTelephonyRoute.value &&
    !isStudioRoute.value
  );
});

const toggleSidebar = () => {
  updateUISettings({
    is_copilot_panel_open: !uiSettings.value.is_copilot_panel_open,
    is_vision_panel_open: false,
    is_contact_sidebar_open: false,
  });
};
</script>

<template>
  <div
    v-if="showCopilotLauncher"
    class="fixed bottom-4 ltr:right-4 rtl:left-4 z-50"
  >
    <div class="rounded-full bg-n-alpha-2 p-1">
      <Button
        icon="i-woot-captain"
        class="!rounded-full !bg-n-solid-3 dark:!bg-n-alpha-2 !text-n-slate-12 text-xl"
        lg
        @click="toggleSidebar"
      />
    </div>
  </div>
  <template v-else />
</template>
